import React, { useState } from 'react';

interface PerScriptGridCardProps {
    item: any;
    onClick?: (item: any) => void;
    onDelete: (id: any) => void
    onView: (item: any) => void
}

const PerScriptGridCard: React.FC<PerScriptGridCardProps> = ({
    item,
    onClick,
    onDelete,
    onView
}) => {
    const [openMenuId, setOpenMenuId] = useState<number | null>(null);

    const handleMenuToggle = (
        e: React.MouseEvent<HTMLButtonElement>,
        id: number
    ) => {
        e.stopPropagation();
        setOpenMenuId(prev => (prev === id ? null : id));
    };

    const handleDeleteAction = (
        e: any
    ) => {
        if (openMenuId) onDelete(item?.id)
        e.stopPropagation();
        setOpenMenuId(null);
    };

    const handleViewAction = (
        e: any
    ) => {
        if (openMenuId) onView(item)
        e.stopPropagation();
        setOpenMenuId(null);
    };

    return (
        <div
            className="collection-card"
            onClick={(e) => {
                if (openMenuId) {
                    e.stopPropagation();
                    setOpenMenuId(null);
                    return
                }
                onClick?.(item)
            }}
        >
            <div className="collection-card__image-wrapper">
                <img
                    src={item?.cover_image_url || '/assets/images/yellow-6th.png'}
                    alt={item?.name || 'Per Script'}
                    className="collection-card__image"
                />
            </div>

            <div className="collection-card__content">
                <div className="collection-card__info">
                    <h3 className="collection-card__title">
                        {item?.name}
                    </h3>

                    <p className="collection-card__subtitle">
                        {`${item?.number_of_episodes || 0} ${item?.number_of_episodes > 1 ? 'Episodes' : 'Episode'}`}
                        {`, ${item?.number_of_scenes || 0} Scenes`}
                    </p>
                </div>

                <div
                    className="collection-card__menu"
                    onClick={e => e.stopPropagation()}
                >
                    <button
                        type="button"
                        className="collection-card__menu-button"
                        aria-label="More options"
                        onClick={e =>
                            handleMenuToggle(e, item?.id)
                        }
                    >
                        <img
                            src="/assets/images/dots-horizontal-rounded.svg"
                            alt=""
                        />
                    </button>

                    {openMenuId === item?.id && (
                        <div className="collection-card__dropdown">
                            <button
                                type="button"
                                className="collection-card__dropdown-item"
                                onClick={handleViewAction}
                            >
                                <img
                                    src="/assets/images/view-meta.svg"
                                    alt=""
                                />
                                <span>View Script</span>
                            </button>
                            <button
                                type="button"
                                className="collection-card__dropdown-item collection-card__dropdown-item--danger"
                                onClick={handleDeleteAction}
                            >
                                <img
                                    src="/assets/images/Delete-icon-red.svg"
                                    alt=""
                                />
                                <span>Delete</span>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PerScriptGridCard;